// ponytail: winston depends on Node core modules (fs/os/stream) that don't
// exist in a browser bundle, so this mirrors winston's info/warn/error/debug
// API using console — the browser's own log sink — instead of shipping the
// winston package to the client.
type Meta = Record<string, unknown>;

function log(consoleFn: (...args: unknown[]) => void, message: unknown, meta?: Meta) {
  if (meta && Object.keys(meta).length) {
    consoleFn(message, meta);
  } else {
    consoleFn(message);
  }
}

export const logger = {
  error: (message: unknown, meta?: Meta) => log(console.error, message, meta),
  warn: (message: unknown, meta?: Meta) => log(console.warn, message, meta),
  info: (message: unknown, meta?: Meta) => log(console.info, message, meta),
  debug: (message: unknown, meta?: Meta) => log(console.debug, message, meta),
};
